export const KEY_PAYMENT = process.env.NODE_ENV === 'development' ? "rzp_test_RNQhhZAuxm117t" : "rzp_test_RNQhhZAuxm117t"
export const COMPANY_NAME = process.env.NODE_ENV === 'development' ? "FABINSTA" : "FABINSTA"
